import React, { useState, useEffect, useRef, useContext } from "react";
import Select from "react-select";
import { NotificationManager } from "react-notifications";
import useApi from "../Api/Api";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import Input from "../Components/Input";
import Button from "../Components/Button";
import SizeRow from "../Components/SizeRow";
import DragAndDrop from "../Components/DragAndDrop";
import { FilterContext } from "../FilterContextProvider";

const AddProduct = ({
  handleShowSelf,
  handleShowManualForm,
  handleShowUploadForm,
  afterSubmit,
  fromArtistPage,
  fromHome,
}) => {
  const [isFetching, setIsFetching] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [submitIsDone, setSubmitIsDone] = useState(false);
  const api = useApi();
  const history = useHistory();
  const categoryRef = useRef();
  const [artists, setArtists] = useState([]);
  const [categories, setCategories] = useState([]);
  const [chosenCategory, setChosenCategory] = useState("");
  const [sizes, setSizes] = useState([]);
  const { filterData, setFilterData } = useContext(FilterContext);
  const [product, setProduct] = useState({
    name: "",
    retail_price: "",
    cost: 0,
    category_id: "",
    size_id: "",
    artist_id: filterData.artist_id,
  });

  const artistOptions = artists.map((artist) => ({
    label: artist.name,
    value: artist.id,
  }));

  const categoryOptions = categories.map((category) => ({
    label: category.name,
    value: category.id,
  }));

  const handleChange = ({ target: { id, value } }) => {
    setProduct({
      ...product,
      [id]: value,
    });
  };

  const handleArtistSelect = (option) => {
    setProduct({ ...product, artist_id: option.value });
    setFilterData({
      ...filterData,
      artist_id: option.value,
      artist_name: option.label,
    });
  };

  const handleCategorySelect = (option) => {
    setProduct({ ...product, category_id: option.value });
    setChosenCategory(option.label);
    if (option.label === "Clothing") {
      setDefaultChecks();
    } else {
      unSetDefaultChecks();
    }
  };

  const handleImage = (r) => {
    setProduct({
      ...product,
      image: r[0],
    });
  };

  const handleAddMore = (event) => {
    event.preventDefault();
    setErrorMessage();
    setSubmitIsDone(false);
    setIsFetching(true);
    if (sizesToAdd.length !== 0) {
      sizesToAdd.forEach((each) => {
        if (!isNaN(each.altPrice) && each.altPrice?.trim() !== "") {
          each.retail_price = each.altPrice;
        } else {
          each.retail_price = product.retail_price;
        }
        if (!isNaN(each.altCost) && each.altCost?.trim() !== "") {
          each.cost = each.altCost;
        } else {
          each.cost = product.cost;
        }
        if (each.size_other && each.size_other?.trim() !== "") {
          each.size_other = each.size_other.trim();
        }
      });
      api
        .put(`/artists/${filterData.artist_id}`, {
          artist: {
            products_attributes: [
              ...sizesToAdd.map((each) => ({
                name: product.name,
                category_id: product.category_id,
                size_id: each.id,
                retail_price: each.retail_price,
                cost: each.cost ? each.cost : 0,
                size_other: each.size_other,
                artist_id: filterData.artist_id,
                image: product.image,
              })),
            ],
          },
        })
        .then((response) => {
          NotificationManager.success("Products successfully added", "Success", 2000);
          afterSubmit();
          categoryRef.current.select?.setValue("");
          setProduct({
            name: "",
            retail_price: "",
            cost: 0,
            artist_id: filterData.artist_id,
          });
          setSizesToAlter(sizes);
          setIsFetching(false);
          sizesToAlter.forEach((size) => {
            size.isToBeAdded = false;
            size.quantity = "";
            size.altPrice = "";
          });
          return response.data;
        })
        .catch((error) => {
          const err = Object.keys(error.response.data.errors).map((key) => {
            const parts = key.split(".");
            const rowNum = parseInt(parts[0].match(/\d+/)) + 1;
            const type = parts[1];
            return `row ${rowNum}: ${type} ${error.response.data.errors[key][0]}`;
          });
          return { err };
        })
        .then((results) => {
          !results.id && setErrorMessage(results);
        })
        .finally(() => {});
      event.preventDefault();
      setIsFetching(false);
      setSubmitIsDone(true);
    } else {
      api
        .put(`/artists/${filterData.artist_id}`, {
          artist: {
            products_attributes: [product],
          },
        })
        .then((response) => {
          NotificationManager.success("Product successfully added", "Success", 2000);
          afterSubmit();
          categoryRef.current.select?.setValue("");
          setProduct({
            name: "",
            retail_price: "",
            cost: 0,
            artist_id: filterData.artist_id,
          });
          setSizesToAlter(sizes);
          sizesToAlter.forEach((size) => {
            size.isToBeAdded = false;
            size.quantity = "";
            size.altPrice = "";
          });
          return response.data;
        })
        .catch((error) => {
          const err = Object.keys(error.response.data.errors).map((key) => {
            const parts = key.split(".");
            const type = parts[1];
            return `${type} ${error.response.data.errors[key][0]}`;
          });
          return { [product.name]: err };
        })
        .then((results) => {
          !results.id && setErrorMessage(results);
        })
        .finally(() => {});
      event.preventDefault();
      setIsFetching(false);
      setSubmitIsDone(true);
    }
  };

  const handleDoneAdding = (event) => {
    event.preventDefault();
    setErrorMessage();
    setSubmitIsDone(false);
    setIsFetching(true);
    if (sizesToAdd.length !== 0) {
      sizesToAdd.forEach((each) => {
        if (!isNaN(each.altPrice) && each.altPrice?.trim() !== "") {
          each.retail_price = each.altPrice;
        } else {
          each.retail_price = product.retail_price;
        }
        if (!isNaN(each.altCost) && each.altCost?.trim() !== "") {
          each.cost = each.altCost;
        } else {
          each.cost = product.cost;
        }
        if (each.size_other && each.size_other?.trim() !== "") {
          each.size_other = each.size_other.trim();
        }
      });
      api
        .put(`/artists/${filterData.artist_id}`, {
          artist: {
            products_attributes: [
              ...sizesToAdd.map((each) => ({
                name: product.name,
                category_id: product.category_id,
                size_id: each.id,
                retail_price: each.retail_price,
                cost: each.cost ? each.cost : 0,
                size_other: each.size_other,
                artist_id: filterData.artist_id,
                image: product.image,
              })),
            ],
          },
        })
        .then((response) => {
          NotificationManager.success("Products successfully added", "Success", 2000);
          history.push("/inventory/manage");
          handleShowManualForm();
          afterSubmit();
          return response.data;
        })
        .catch((error) => {
          const err = Object.keys(error.response.data.errors).map((key) => {
            const parts = key.split(".");
            const rowNum = parseInt(parts[0].match(/\d+/)) + 1;
            const type = parts[1];
            return `row ${rowNum}: ${type} ${error.response.data.errors[key][0]}`;
          });
          return { err };
        })
        .then((results) => {
          !results.id && setErrorMessage(results);
        })
        .finally(() => {});
      event.preventDefault();
      setIsFetching(false);
      setSubmitIsDone(true);
    } else {
      api
        .put(`/artists/${filterData.artist_id}`, {
          artist: {
            products_attributes: [product],
          },
        })
        .then((response) => {
          NotificationManager.success("Product successfully added", "Success", 2000);
          history.push("/inventory/manage");
          handleShowManualForm();
          afterSubmit();
          return response.data;
        })
        .catch((error) => {
          const err = Object.keys(error.response.data.errors).map((key) => {
            const parts = key.split(".");
            const type = parts[1];
            return `${type} ${error.response.data.errors[key][0]}`;
          });
          return { [product.name]: err };
        })
        .then((results) => {
          !results.id && setErrorMessage(results);
        })
        .finally(() => {});
      event.preventDefault();
      setIsFetching(false);
      setSubmitIsDone(true);
    }
  };

  useEffect(() => {
    api.get(`/artists`).then((r) => {
      setArtists(r.data);
    });
    api.get(`/categories`).then((r) => {
      setCategories(r.data);
    });
    api.get(`/sizes`).then((r) => {
      setSizes(r.data);
    });
  }, [api]);

  const [sizesToAlter, setSizesToAlter] = useState([]);

  useEffect(() => {
    setSizesToAlter([...sizes]);
  }, [sizes]);

  const setDefaultChecks = () => {
    const newSizes = sizesToAlter.map((obj, i) =>
      ["S", "M", "L", "XL", "XXL"].includes(sizesToAlter[i].name) ? { ...obj, isToBeAdded: true } : obj
    );
    setSizesToAlter(newSizes);
  };

  const unSetDefaultChecks = () => {
    setSizesToAlter([...sizes]);
  };

  const handleCheckChange = (sizeIdx, checkState) => {
    const newSizes = sizesToAlter.map((obj, i) => (i === sizeIdx ? { ...obj, isToBeAdded: checkState } : obj));
    setSizesToAlter(newSizes);
  };

  const handlePriceChange = (event) => {
    const newSizes = sizesToAlter.map((obj, i) =>
      i === parseInt(event.target.id) ? { ...obj, altPrice: event.target.value } : obj
    );
    setSizesToAlter(newSizes);
  };

  const handleCostChange = (event) => {
    const newSizes = sizesToAlter.map((obj, i) =>
      i === parseInt(event.target.id) ? { ...obj, altCost: event.target.value } : obj
    );
    setSizesToAlter(newSizes);
  };

  const handleCustomNameChange = (event) => {
    const newSizes = sizesToAlter.map((obj, i) =>
      i === parseInt(event.target.id) ? { ...obj, size_other: event.target.value, isToBeAdded: true } : obj
    );
    setSizesToAlter(newSizes);
  };

  const addRow = (event) => {
    event.preventDefault();
    const newProduct = { ...product };
    setSizesToAlter([...sizesToAlter, newProduct]);
  };

  const sizesToAdd = sizesToAlter.filter((each) => each.isToBeAdded === true);

  return (
    <div className="-mt-20 side-modal">
      <div className="flex-col">
        <header className="py-6 px-4 text-lg mb-2 bg-blue-500 text-white">
          <button onClick={handleShowManualForm} className="float-right -mt-4">
            <FontAwesomeIcon icon={faTimes}></FontAwesomeIcon>
          </button>
          {fromArtistPage && (
            <div className="-mt-4">
              <button onClick={handleShowSelf} className="-pt-5 text-xs tracking-wide">
                <FontAwesomeIcon icon={faArrowLeft}></FontAwesomeIcon> Back to{" "}
                <span className="italics">add artist</span>
              </button>
            </div>
          )}
          <div>
            Add Product
            {filterData.artist_name && (
              <>
                {" "}
                for
                <span className="font-bold"> {filterData.artist_name}</span>
              </>
            )}
          </div>
          <div className="text-sm">
            Enter your product details below or click{" "}
            <button onClick={handleShowUploadForm} className="font-bold underline">
              here
            </button>{" "}
            to import from another source
          </div>
        </header>
        <div className="mt-6 px-4 font-normal text-black text-lg">Product Details</div>
        <hr className="my-2 mx-4"></hr>
        <form className="mx-4 text-sm">
          {fromHome && (
            <>
              <label htmlFor="artist_id">Artist</label>
              <Select
                id="artist_id"
                placeholder="Select an artist"
                className="text-xs font-light mt-1"
                options={artistOptions}
                value={artistOptions?.filter((each) => each.value === filterData.artist_id)}
                onChange={(option) => handleArtistSelect(option)}
              />
            </>
          )}
          <div className="my-3">
            <label htmlFor="name">Name</label>
            <div className="w-full mt-1">
              <Input
                id="name"
                type="name"
                label="Name"
                hideLabel
                value={product.name}
                name="name"
                onChange={handleChange}
                disabled={isFetching}
                required
              />
            </div>
          </div>
          <div className="items-end flex mt-5">
            <div className="w-1/3 pr-5">
              <label htmlFor="retail_price">Retail price</label>
              <div className="mt-2">
                <Input
                  id="retail_price"
                  type="retail_price"
                  label="Retail price"
                  hideLabel
                  value={product.retail_price}
                  name="retail_price"
                  onChange={handleChange}
                  disabled={isFetching}
                />
              </div>
            </div>
            <div className="w-1/3 pr-5">
              <label htmlFor="cost">Cost</label>
              <div className="mt-2">
                <Input
                  id="cost"
                  type="cost"
                  label="Cost"
                  hideLabel
                  value={product.cost}
                  name="cost"
                  onChange={handleChange}
                  disabled={isFetching}
                />
              </div>
            </div>
            <div className="w-1/2">
              <label htmlFor="category">Category</label>
              <div className="w-full mt-1">
                <Select
                  id="category"
                  className="text-xs font-light"
                  options={categoryOptions}
                  onChange={handleCategorySelect}
                  ref={categoryRef}
                />
              </div>
            </div>
          </div>
          {chosenCategory === "Clothing" && (
            <div>
              <div className="mt-7 text-base -ml-4 px-4	font-normal text-black">Inventory Details</div>
              <hr className="my-3"></hr>
              <div>
                <div className="text-center">
                  <div className="text-xs font-light">
                    <div className="text-black tracking-normal flex">
                      <div className="w-1/3 pb-3">SIZES</div>
                      <div className="w-1/3 pb-3 pr-2">ALT. PRICE</div>
                      <div className="w-1/3 pb-3 pr-2">ALT. COST</div>
                    </div>
                  </div>
                  {sizesToAlter.map((size, i) => {
                    return (
                      <div key={i}>
                        <SizeRow
                          key={i}
                          size={size}
                          sizeIdx={i}
                          handleCheckChange={handleCheckChange}
                          handlePriceChange={handlePriceChange}
                          handleCostChange={handleCostChange}
                          handleCustomNameChange={handleCustomNameChange}
                        />
                        <div className="text-red-500 text-left pb-4 pl-4">
                          {errorMessage?.err &&
                            size.isToBeAdded &&
                            `${errorMessage?.err[i - 1]?.split("name")[1]?.slice()}`}
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="grid justify-items-center my-4">
                  <Button
                    text={"Add Additional Size"}
                    disabled={isFetching}
                    className="button button-lg mr-2"
                    onClick={addRow}
                  ></Button>
                </div>
              </div>
            </div>
          )}
          <hr className="my-3"></hr>
          <DragAndDrop handleImage={handleImage} product={product} />
          <div className="flex justify-center mt-8">
            {errorMessage &&
              submitIsDone &&
              !errorMessage?.err &&
              Object.keys(errorMessage).map((product, i) => (
                <div key={i} className="text-red-500 pb-4">
                  {errorMessage[product].map((each, j) => (
                    <div key={j}>{each}</div>
                  ))}
                </div>
              ))}
          </div>
          <div className="flex justify-end my-8">
            <div>
              <div></div>
              <div className="flex float-right">
                <Button
                  text={isFetching ? `Loading ${"\u00A0"}` : "Add more"}
                  onClick={handleAddMore}
                  disabled={isFetching}
                  inProgress={isFetching}
                  className="button button-white mr-2"
                ></Button>
                <Button
                  text={isFetching ? `Loading ${"\u00A0"}` : "Done adding"}
                  onClick={handleDoneAdding}
                  disabled={isFetching}
                  inProgress={isFetching}
                  className="button"
                ></Button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddProduct;
